/* Jewels & Chains: live "Total for N ft" on by-the-foot products.
   Currency-agnostic — scales the number inside whatever the page rendered for 1 ft. */
(function () {
  function parseAmount(text) {
    var m = text.match(/\d[\d.,]*/);
    if (!m) return null;
    var raw = m[0], dec = null;
    if (/[.,]\d{2}$/.test(raw) && raw.length > 3) dec = raw.charAt(raw.length - 3);
    var thou = dec === ',' ? '.' : ',';
    var num = parseFloat(raw.split(thou).join('').replace(dec || '.', '.'));
    return { raw: raw, dec: dec, thou: thou, num: num, text: text };
  }
  function format(n, p) {
    var parts = n.toFixed(p.dec ? 2 : 0).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, p.thou);
    return parts.join(p.dec || '.');
  }
  function qtyFor(box) {
    var section = box.closest('.product__info-container') || box.closest('.product') || document;
    var input = section.querySelector('input[name="quantity"]');
    var q = input ? parseInt(input.value, 10) : 1;
    return q && q > 0 ? q : 1;
  }
  function update() {
    var boxes = document.querySelectorAll('[data-jc-total]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var a = box.querySelector('[data-jc-amount]'), q = box.querySelector('[data-jc-qty]');
      if (!a) continue;
      if (!box._jcBase) box._jcBase = parseAmount(a.textContent);
      if (!box._jcBase) continue;
      var qty = qtyFor(box);
      if (q) q.textContent = qty;
      a.textContent = box._jcBase.text.replace(box._jcBase.raw, format(box._jcBase.num * qty, box._jcBase));
    }
  }
  document.addEventListener('input', function (e) { if (e.target.name === 'quantity') update(); });
  document.addEventListener('change', function (e) { if (e.target.name === 'quantity') update(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(update, 0);
  });
  if (document.readyState !== 'loading') setTimeout(update, 800);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(update, 800); });

  /* Product video row: play only while on screen, pause when scrolled away. Respects reduced-motion. */
  function reels() {
    var vids = document.querySelectorAll('.jc-reels__video');
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target, item = v.closest('.jc-reels__item');
        if (e.isIntersecting) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          item && item.classList.add('is-playing');
        } else { v.pause(); item && item.classList.remove('is-playing'); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.loop = true; io.observe(v); });
  }
  if (document.readyState !== 'loading') reels(); else document.addEventListener('DOMContentLoaded', reels);

  /* Product gallery arrows on desktop: Dawn's arrows only scroll the mobile slider, so on
     desktop we step the active media ourselves through the gallery's own setActiveMedia. */
  function galleryArrows() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var buttons = gallery.querySelector('.slider-mobile-gutter:not(.thumbnail-slider) .slider-buttons');
    if (!buttons) return;
    var items = function () { return Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item')); };
    var enable = function () { buttons.querySelectorAll('.slider-button').forEach(function (b) { b.removeAttribute('disabled'); }); };
    buttons.addEventListener('click', function (e) {
      var btn = e.target.closest('.slider-button');
      if (!btn || window.innerWidth < 990) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var list = items(); if (list.length < 2) return;
      var idx = list.findIndex(function (li) { return li.classList.contains('is-active'); });
      if (idx < 0) idx = 0;
      var next = btn.name === 'next' ? (idx + 1) % list.length : (idx - 1 + list.length) % list.length;
      var id = list[next].dataset.mediaId;
      if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(id, false);
      var thumb = gallery.querySelector('.thumbnail[data-target="' + id + '"]');
      if (thumb && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest' });
      enable();
    }, true);
    enable();
    new MutationObserver(enable).observe(buttons, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
    /* Thumbnails sit in a scrolling column, so lazy-loading leaves them blank until scrolled; load them now. */
    gallery.querySelectorAll('.thumbnail img, .product__media img').forEach(function (img) { img.loading = 'eager'; if (img.dataset.src && !img.src) img.src = img.dataset.src; });
  }
  if (document.readyState !== 'loading') galleryArrows(); else document.addEventListener('DOMContentLoaded', galleryArrows);

  /* Variant option values in numeric order (22mm before 34mm, 2 before 10), pills and dropdowns alike. */
  var sorting = false;
  function sortVariantValues(root) {
    if (sorting) return;
    sorting = true;
    try {
      var num = function (t) {
        var s = String(t).trim();
        // Money amounts ("Coverage for $1.000", "$10,000"): a separator followed by exactly three
        // digits is a thousands separator, not a decimal point. Read as a decimal, $1.000 sorted before $200.
        var money = s.match(/\$\s*(\d{1,3}(?:[.,]\d{3})+(?!\d)|\d+(?:\.\d+)?)/);
        if (money) return parseFloat(/[.,]\d{3}$/.test(money[1]) ? money[1].replace(/[.,]/g, '') : money[1]);
        var m = s.match(/-?\d+(?:\.\d+)?/);
        return m ? parseFloat(m[0]) : Number.POSITIVE_INFINITY;
      };
      var isSorted = function (keys) { for (var i = 1; i < keys.length; i++) if (keys[i] < keys[i - 1]) return false; return true; };
      (root || document).querySelectorAll('.product-form__input--pill, .product-form__input--swatch').forEach(function (fs) {
        if (fs.dataset.jcSorted === '1') return;
        var inputs = Array.prototype.slice.call(fs.querySelectorAll(':scope > input[type=radio]'));
        if (inputs.length < 2) return;
        var pairs = inputs.map(function (i) { return { i: i, l: i.nextElementSibling, k: num(i.value) }; });
        if (pairs.some(function (p) { return !isFinite(p.k); })) return;
        fs.dataset.jcSorted = '1';
        if (isSorted(pairs.map(function (p) { return p.k; }))) return;
        pairs.sort(function (a, b) { return a.k - b.k; });
        pairs.forEach(function (p) { fs.appendChild(p.i); if (p.l) fs.appendChild(p.l); });
      });
      (root || document).querySelectorAll('.product-form__input--dropdown select').forEach(function (sel) {
        if (sel.dataset.jcSorted === '1') return;
        var opts = Array.prototype.slice.call(sel.options);
        if (opts.length < 2 || opts.some(function (o) { return !isFinite(num(o.value)); })) return;
        sel.dataset.jcSorted = '1';
        if (isSorted(opts.map(function (o) { return num(o.value); }))) return;
        var cur = sel.value;
        opts.sort(function (a, b) { return num(a.value) - num(b.value); }).forEach(function (o) { sel.appendChild(o); });
        sel.value = cur;
      });
    } finally { sorting = false; }
  }
  if (document.readyState !== 'loading') sortVariantValues(); else document.addEventListener('DOMContentLoaded', function () { sortVariantValues(); });
  /* Dawn re-renders the picker after a variant change; re-sort once per render, never in a loop. */
  document.addEventListener('DOMContentLoaded', function () {
    var pi = document.querySelector('.product__info-container');
    if (!pi || !('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending || sorting) return;
      if (!muts.some(function (m) { return m.target.closest && !m.target.closest('[data-jc-sorted="1"]'); })) return;
      pending = true;
      setTimeout(function () { pending = false; sortVariantValues(pi); }, 50);
    }).observe(pi, { childList: true, subtree: true });
  });

  /* Long header dropdowns become multi-column boxes with an "All …" link on top. */
  function megaMenus() {
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      var ul = d.querySelector('.header__submenu.list-menu');
      if (!ul || ul.querySelectorAll(':scope > li').length <= 12) return;
      d.classList.add('jc-mega');
      var top = d.querySelector('summary .header__menu-item, summary');
      var label = top ? top.textContent.trim() : '';
      var href = d.querySelector('summary a') ? d.querySelector('summary a').getAttribute('href') : null;
      if (!href) {
        var guess = ul.querySelector('a[href*="/collections/"]');
        href = guess ? guess.getAttribute('href').split('/').slice(0, 3).join('/') : null;
      }
      if (label && !ul.querySelector('.jc-mega__all')) {
        var li = document.createElement('li'); li.className = 'jc-mega__all';
        li.innerHTML = href ? '<a href="' + href + '">All ' + label.toLowerCase() + ' &rarr;</a>' : label;
        ul.insertBefore(li, ul.firstChild);
      }
    });
  }
  if (document.readyState !== 'loading') megaMenus(); else document.addEventListener('DOMContentLoaded', megaMenus);

  /* Homepage hero (sections/jc-hero.liquid): cross-fading slides, auto-advance that
     pauses on hover/focus and is off for reduced motion, swipe, and late loading of
     the photos on slides after the first. */
  function heroes() {
    document.querySelectorAll('[data-jc-hero]').forEach(function (root) {
      if (root.dataset.jcReady) return;
      root.dataset.jcReady = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var bars = Array.prototype.slice.call(root.querySelectorAll('[data-go]'));
      var current = root.querySelector('[data-current]');
      var index = 0, timer = null, hydrated = false;
      var speed = parseInt(root.dataset.speed || '0', 10) * 1000;
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function hydrate() {
        if (hydrated) return;
        hydrated = true;
        root.querySelectorAll('img[data-src]').forEach(function (img) {
          img.loading = 'eager';
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
      }
      function tint() { root.style.setProperty('--nav', getComputedStyle(slides[index]).getPropertyValue('--fg')); }
      function show(i) {
        hydrate();
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === index);
          if (k === index) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        bars.forEach(function (b, k) { if (k === index) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        if (current) current.textContent = ('0' + (index + 1)).slice(-2);
        tint();
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() { stop(); if (speed > 0 && !still && slides.length > 1) timer = setInterval(advance, speed); }
      /* Do not auto-advance onto a slide whose photos have not arrived yet. */
      function advance() {
        var next = slides[(index + 1) % slides.length];
        var ready = Array.prototype.every.call(next.querySelectorAll('img'), function (img) { return img.complete && img.naturalWidth > 0; });
        if (ready) show(index + 1); else hydrate();
      }
      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-go],[data-prev],[data-next]');
        if (!t) return;
        if (t.hasAttribute('data-go')) show(parseInt(t.dataset.go, 10));
        else show(index + (t.hasAttribute('data-next') ? 1 : -1));
        play();
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { show(index + (dx < 0 ? 1 : -1)); play(); }
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
      tint();
      if (document.readyState === 'complete') setTimeout(hydrate, 1200); else window.addEventListener('load', function () { setTimeout(hydrate, 1200); });
      play();
    });
  }
  if (document.readyState !== 'loading') heroes(); else document.addEventListener('DOMContentLoaded', heroes);
  document.addEventListener('shopify:section:load', heroes);

  /* Cart: "Request a trade quote" (next to Check out, or arriving on /cart#trade-quote) opens the form and brings it into view. */
  function openTradeQuote() {
    var box = document.getElementById('trade-quote');
    if (!box) return false;
    var details = box.querySelector('details');
    if (details) details.open = true;
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var first = box.querySelector('input:not([type="hidden"])');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#trade-quote"]');
    if (a && openTradeQuote()) e.preventDefault();
  });
  if (location.hash === '#trade-quote') { if (document.readyState !== 'loading') openTradeQuote(); else document.addEventListener('DOMContentLoaded', openTradeQuote); }

  /* Cart terms checkbox (snippets/jc-terms.liquid): every copy stays in sync, the answer is
     remembered for the session, and Check out is blocked until it is ticked. Dawn re-renders
     the cart and drawer after every change, so state is re-applied whenever the DOM changes. */
  var TERMS_KEY = 'jcTermsAgreed';
  function termsAgreed() { try { return sessionStorage.getItem(TERMS_KEY) === '1'; } catch (e) { return false; } }
  function termsBoxes() { return document.querySelectorAll('[data-jc-terms] .jc-terms__box'); }
  function syncTerms() {
    var boxes = termsBoxes(), ok = termsAgreed();
    boxes.forEach(function (b) { if (b.checked !== ok) b.checked = ok; });
    document.documentElement.classList.toggle('jc-terms-pending', boxes.length > 0 && !ok);
  }
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('jc-terms__box')) return;
    try { sessionStorage.setItem(TERMS_KEY, e.target.checked ? '1' : '0'); } catch (err) {}
    document.querySelectorAll('[data-jc-terms]').forEach(function (t) {
      t.classList.remove('is-missing');
      var msg = t.querySelector('.jc-terms__error'); if (msg) msg.hidden = true;
    });
    syncTerms();
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn || termsBoxes().length === 0 || termsAgreed()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var scope = btn.closest('.jc-cart-top, .cart__footer, .cart-drawer, cart-drawer') || document;
    var box = scope.querySelector('[data-jc-terms]') || document.querySelector('[data-jc-terms]');
    box.classList.add('is-missing');
    var msg = box.querySelector('.jc-terms__error'); if (msg) msg.hidden = false;
    var input = box.querySelector('.jc-terms__box'); if (input) input.focus();
  }, true);
  /* Trade quote gate (snippets/jc-trade-gate.liquid): shown only when the cart is worth at least the
     trade threshold in the shop currency. Liquid decides for shop-currency carts; here it is redone
     after the cart re-renders (the top bar carries the fresh total) and for other currencies, using
     Shopify.currency.rate to convert. Setting .hidden is an attribute change, so it does not retrigger
     the childList observer below. */
  function syncTrade() {
    var gates = document.querySelectorAll('[data-jc-trade-gate]');
    if (!gates.length) return;
    var fresh = document.querySelector('.jc-cart-top [data-jc-trade-gate]');
    gates.forEach(function (g) {
      var ref = (fresh && !g.closest('cart-drawer')) ? fresh : g;
      var total = parseFloat(ref.dataset.total), threshold = parseFloat(ref.dataset.threshold), rate = 1;
      if (ref.hasAttribute('data-convert')) rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 0);
      var show = rate > 0 && threshold > 0 && (total / rate) >= threshold;
      if (g.hidden === show) g.hidden = !show;
    });
  }
  var termsTimer = null;
  function syncCart() { syncTerms(); syncTrade(); }
  function watchTerms() {
    syncCart();
    new MutationObserver(function () { clearTimeout(termsTimer); termsTimer = setTimeout(syncCart, 60); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') watchTerms(); else document.addEventListener('DOMContentLoaded', watchTerms);

  /* Cart shipping estimator (sections/jc-cart-extras.liquid): provinces per country from the
     data-provinces attribute Shopify puts on each country option, rates from /cart/shipping_rates.json. */
  function shipEstimators() {
    document.querySelectorAll('[data-jc-ship]').forEach(function (form) {
      if (form.dataset.jcReady) return;
      form.dataset.jcReady = '1';
      var country = form.elements.country, province = form.elements.province, zip = form.elements.zip;
      var wrap = form.querySelector('[data-province]');
      var out = form.parentNode.querySelector('[data-jc-ship-result]');
      function fillProvinces() {
        var opt = country.options[country.selectedIndex];
        var list = [];
        try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) {}
        province.innerHTML = '';
        list.forEach(function (p) { var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; province.appendChild(o); });
        wrap.hidden = list.length === 0;
        if (province.dataset.default) province.value = province.dataset.default;
        if (province.selectedIndex < 0 && province.options.length) province.selectedIndex = 0;
      }
      if (country.dataset.default) {
        for (var i = 0; i < country.options.length; i++) { if (country.options[i].value === country.dataset.default) { country.selectedIndex = i; break; } }
      }
      fillProvinces();
      country.addEventListener('change', function () { province.dataset.default = ''; fillProvinces(); });
      function show(html, bad) { out.innerHTML = html; out.classList.toggle('is-error', !!bad); }
      function money(amount, currency) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(amount); } catch (e) { return amount + ' ' + currency; }
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = 'shipping_address[country]=' + encodeURIComponent(country.value) +
          '&shipping_address[province]=' + encodeURIComponent(wrap.hidden ? '' : province.value) +
          '&shipping_address[zip]=' + encodeURIComponent(zip.value.trim());
        show('Checking rates…');
        var tries = 0;
        (function ask() {
          fetch('/cart/shipping_rates.json?' + q, { headers: { Accept: 'application/json' } }).then(function (r) {
            if (r.status === 202 && tries++ < 8) { setTimeout(ask, 700); return null; }
            return r.json().then(function (data) { return { ok: r.ok, data: data }; });
          }).then(function (res) {
            if (!res) return;
            if (!res.ok) {
              var parts = [];
              Object.keys(res.data || {}).forEach(function (k) { parts.push(k + ' ' + [].concat(res.data[k]).join(', ')); });
              show(parts.length ? 'Could not estimate: ' + parts.join('; ') + '.' : 'Could not estimate shipping for that address.', true);
              return;
            }
            var rates = (res.data && res.data.shipping_rates) || [];
            if (!rates.length) { show('No rate came back for this cart and address. Shipping is confirmed at checkout, or contact us and we will quote it.', true); return; }
            var rows = rates.map(function (rate) {
              var price = parseFloat(rate.price);
              return '<li><span>' + String(rate.presentment_name || rate.name).replace(/[<>&]/g, '') + '</span><strong>' + (price === 0 ? 'Free' : money(price, rate.currency)) + '</strong></li>';
            }).join('');
            show('Rates for this cart, before any checkout discounts:<ul>' + rows + '</ul>');
          }).catch(function () { show('Could not reach the shipping calculator. Please try again.', true); });
        })();
      });
    });
  }
  if (document.readyState !== 'loading') shipEstimators(); else document.addEventListener('DOMContentLoaded', shipEstimators);

  /* Cart insurance picker (snippets/jc-insurance-row.liquid): add the chosen coverage as a cart
     line. In the drawer, Dawn re-renders the drawer from the response; on the cart page, reload. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.jc-terms a[href^="#jc-insure-"]');
    if (link) {
      var target = document.getElementById(link.getAttribute('href').slice(1));
      var sel = target && target.querySelector('select');
      e.preventDefault();
      if (sel) sel.focus(); else if (target) target.scrollIntoView({ block: 'center' });
      return;
    }
    var btn = e.target.closest && e.target.closest('.jc-insure__add');
    if (!btn) return;
    var box = btn.closest('[data-jc-insure]');
    var select = box.querySelector('.jc-insure__select');
    var err = box.querySelector('.jc-insure__error');
    var drawer = btn.closest('cart-drawer');
    var body = { id: parseInt(select.value, 10), quantity: 1 };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…'; err.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add insurance.');
        if (drawer && drawer.renderContents && res.data.sections) drawer.renderContents(res.data);
        else window.location.reload();
      })
      .catch(function (error) {
        btn.disabled = false; btn.textContent = label;
        err.textContent = error.message || 'Could not add insurance. Please try again.'; err.hidden = false;
      });
  });

  /* Make "shop by material" tiles clickable as a whole (the link text is kept for screen readers). */
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.multicolumn-card');
    if (!card || e.target.closest('a')) return;
    var link = card.querySelector('a.link, a[href]');
    if (link && link.getAttribute('href')) window.location.href = link.getAttribute('href');
  });
})();

